import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { UnitProvider } from "@/context/UnitContext";
import { Layout } from "@/components/Layout";
import { Home } from "@/pages/Home";
import { CalculatorsPage } from "@/pages/CalculatorsPage";
import { ArticlesIndex } from "@/pages/ArticlesIndex";
import { ArticlePage } from "@/pages/ArticlePage";
import { AboutPage } from "@/pages/AboutPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { ContactPage } from "@/pages/ContactPage";

function App() {
    return (
        <UnitProvider>
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/calculators" element={<CalculatorsPage />} />

                        {/* Blog */}
                        <Route path="/blog" element={<ArticlesIndex />} />
                        <Route path="/blog/:slug" element={<ArticlePage />} />
                        {/* Legacy /articles routes — keep working */}
                        <Route path="/articles" element={<Navigate to="/blog" replace />} />
                        <Route path="/articles/:slug" element={<ArticlePage />} />

                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />

                        {/* Privacy — canonical /privacy-policy, legacy /privacy redirects */}
                        <Route path="/privacy-policy" element={<PrivacyPage />} />
                        <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </UnitProvider>
    );
}

export default App;
